<template>
  <PageLayout>
    <PageHeader
      :title="$t(`Common.title.homeTitle`)"
      :breadcrumb="[
        {
          title: `${$t('Common.title.homeTitle')}`,
        },
        {
          title: `${this.$t(
            `Common.title.${this.$route.params?.name?.toString()}`
          )}`,
        },
      ]"
    />
    <m-page-header
      class="pl-4"
      :title="$t(`apply.title.searchInfo`)"
    ></m-page-header>
    <m-form ref="form" class="pl-4">
      <m-row :gutter="24">
        <m-col span="20">
          <m-input
            is-form-item
            v-model="form.cardNoOrTaxNo"
            :label="$t('apply.message.taxAndIdNumTip')"
            :placeholder="$t('apply.message.taxAndIdNumTip')"
            :rules="[
              {
                required: true,
                message: $t('Common.message.required'),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="20">
          <m-input
            is-form-item
            v-model="form.applicationNo"
            :label="$t('apply.title.applyNumber')"
            :placeholder="$t('apply.title.applyNumber')"
            :rules="[
              {
                required: true,
                message: $t('Common.message.required'),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="20">
          <m-input
            ref="mobileNum"
            is-form-item
            :maxLength="form.areaCode === '+86' ? 11 : 8"
            :label="$t('apply.title.phoneNumber')"
            v-model.trim="form.mobile"
            :placeholder="$t('Common.message.pleaseEnter')"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
              {
                pattern: phoneFormat(form.areaCode),
                message: this.$t('Common.title.formatError'),
              },
              {
                validator: (rule, v) =>
                  (!form.mobile && !form.areaCode) ||
                  (!!form.mobile && !!form.areaCode),
                isRequired: true,
              },
            ]"
          >
            <template v-slot:contentPrefix>
              <m-select
                layout="vertical"
                option-filter-prop="children"
                v-model="form.areaCode"
                :placeholder="$t('Common.message.pleaseSel')"
                :options="areaCodeOptions"
                :dropdownMatchSelectWidth="false"
                :class="
                  isMobile ? 'combination__field_mobile' : 'combination__field'
                "
                @change="form.areaCode = $event"
              />
            </template>
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="20">
          <m-input
            is-form-item
            :maxLength="6"
            v-model="form.otp"
            :placeholder="$t('apply.message.inPutVerificationCode')"
            :label="$t('apply.title.SMSVerificationCode')"
            :rules="[
              {
                required: true,
                message: $t('apply.message.inPutVerificationCode'),
              },
            ]"
          >
            <template v-slot:contentSuffix>
              <m-button
                style="margin-left: 10px"
                type="primary"
                size="small"
                @click="sendSMS"
                :disabled="!form.mobile || countdown > 0 ? true : false"
                >{{ timeTip }}</m-button
              >
            </template>
          </m-input>
        </m-col>
      </m-row>
    </m-form>
    <template slot="actions">
      <m-button
        type="primary"
        ghost
        size="large"
        @click="onClose"
        class="mr-4"
        >{{ this.$t('Common.action.back') }}</m-button
      >
      <m-button type="primary" size="large" @click="onNext">{{
        this.$t('Common.action.nextStep')
      }}</m-button>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/Layout/web/PageLayout.vue';
import { ApplyAPI, CaptchaAPI } from '@/api';
import { getAreaCodeOptions } from 'govmo-common/src/utils/options';
import { is_mobile, phoneFormat } from 'govmo-common/src/utils/utils';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';

function debounce(func, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
export default {
  components: {
    PageLayout,
    PageHeader,
  },
  data() {
    return {
      areaCodeOptions: getAreaCodeOptions(),
      isMobile: is_mobile(),
      form: { areaCode: '+853' },
      searchData: {},
      timeTip: this.$t('apply.button.receive'),
      timer: 0,
      intervalId: null,
      countdown: 0,
    };
  },
  computed: {
    isCounting() {
      return this.countdown > 0;
    },
  },
  beforeDestroy() {
    this.intervalId && clearInterval(this.intervalId);
  },
  methods: {
    phoneFormat,
    // onPrevious() {
    //   this.$emit('previous');
    // },
    onClose() {
      this.$router.back();
    },
    async onNext() {
      if (!(await this.$refs.form.validateFields())) return;
      await this.queryData();
    },
    async queryData() {
      this.$showLoading();
      try {
        let apiAreaCode = this.form.areaCode?.replace(/\+/g, '');
        this.searchData = await ApplyAPI.ApplyQuery(
          this.form.cardNoOrTaxNo,
          this.form.applicationNo,
          apiAreaCode + this.form.mobile,
          this.form.otp
        );
        // this.$emit('next', { ...this.form, ...this.searchData });
        this.$router.push({
          name: `searchResult`,
          params: {
            formData: { ...this.form, ...this.searchData },
          },
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    //倒計時
    startCountdown: debounce(async function () {
      if (this.isCounting) return;

      this.countdown = 60;
      this.updateTimeTip();

      const interval = setInterval(() => {
        this.countdown -= 1;
        this.updateTimeTip();

        if (this.countdown <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    }, 500),
    updateTimeTip() {
      if (this.countdown > 0) {
        this.timeTip = this.$t('apply.title.receiveAgain', {
          number: this.countdown,
        });
      } else {
        this.timeTip = this.$t('apply.button.receive');
      }
    },
    // startCountdown: debounce(async function () {
    //   this.intervalId && clearInterval(this.intervalId);
    //   this.timer = 60;
    //   this.intervalId = setInterval(() => {
    //     if (this.timer > 0) {
    //       this.timer -= 1;
    //       this.timeTip = this.$t('apply.title.receiveAgain', {
    //         number: this.timer,
    //       });
    //     } else {
    //       this.intervalId = null;
    //       clearInterval(this.intervalId);
    //       this.timeTip = this.$t('apply.button.receive');
    //     }
    //   }, 1000);
    // }, 500),
    async sendSMS() {
      try {
        this.$showLoading();
        let apiAreaCode = this.form.areaCode?.replace(/\+/g, '');
        await CaptchaAPI.getQuerySMS({
          applicationNo: this.form.applicationNo,
          mobile: apiAreaCode + this.form.mobile,
        });
        this.startCountdown();
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.combination__field {
  width: 20%;
}
.combination__field_mobile {
  width: 43%;
}
::v-deep .m-form-item-wrapper .m-form-item-main {
  align-items: center;
}
</style>
